export enum ViewType {
  ListView = 0,
  GridView = 1
}
